import React from 'react';
export function DeleteIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.011 5.013l-5-.007v-2a2 2 0 00-2-2l-4-.006a2 2 0 00-2 2v2h-5a1 1 0 000 2h1l-.019 13a3 3 0 002.995 3l10 .016a3 3 0 003-3l.019-13h1a1 1 0 100-2l.005-.003zM10.013 3l4 .006v2h-4V3zm7.975 17.012a1 1 0 01-1 1l-10-.016a1 1 0 01-1-1l.019-13 6 .009h6l-.019 13.007z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 9.005a1 1 0 00-1 1l-.012 8a1 1 0 002 0l.012-8a1 1 0 00-1-1z"
  }));
}